import React from "react";
import {NavLink } from "react-router-dom";

function SingleCollection(props) {
    return (                        <NavLink to="collection.html" className="single-collection" data-count={props.count}>
    <div className="collection-img">
        <img src="/img/collections/collection1.png" alt="" />
    </div>
    <div className="content">
        <h5>{props.name}</h5>
        <span>{props.price}</span>
    </div>
</NavLink>);
}

export default SingleCollection;